@if (machines) {
    <div class="hdmui hdmui-m-0 sign-off hdmui-container" data-testid="sign-off-dialog">
        <header>
            <mat-toolbar class="sign-off__header">
                <h2>{{ 'DC.SIGN_OFF_DIALOG.TITLE' | translate }}</h2>
            </mat-toolbar>
        </header>
        <section class="hdmui-content sign-off__content">
            @if (config$ | async; as config) {
                <mat-stepper [linear]="true" (selectionChange)="actionButtonHandle($event)">
                    <ng-template matStepperIcon="edit">
                        <mat-icon class="sign-off__done_icon" svgIcon="hdmui:hook"></mat-icon>
                    </ng-template>
                    @if (config.workstations) {
                        <mat-step
                            [label]="'DC.SIGN_OFF_DIALOG.WORKSTATIONS.TITLE' | translate"
                            [stepControl]="dialogForm.controls[SignOffDialogStep.WORKSTATIONS]"
                            [editable]="true"
                            [state]="SignOffDialogStep.WORKSTATIONS"
                        >
                            <data-terminal-sign-off-workstations
                                [machines]="machines || []"
                                [otherActivities]="(otherActivities$ | async)!"
                                (selectMachines)="onWorkstationStateChange($event)"
                                (isValid)="setStepValidity(SignOffDialogStep.WORKSTATIONS, $event)"
                            ></data-terminal-sign-off-workstations>
                        </mat-step>
                    }
                    @if (config.employees) {
                        <mat-step
                            [label]="'DC.SIGN_OFF_DIALOG.EMPLOYEES.TITLE' | translate"
                            [stepControl]="dialogForm.controls[SignOffDialogStep.EMPLOYEES]"
                            [editable]="true"
                            [state]="SignOffDialogStep.EMPLOYEES"
                        >
                            <data-terminal-sign-off-employees
                                [userId]="dialogData.userId"
                                [signOffMachines]="(machinesToSignOff$ | async) || []"
                                (dataChange)="onEmployeesStateChange($event)"
                                (isValid)="setStepValidity(SignOffDialogStep.EMPLOYEES, $event)"
                            ></data-terminal-sign-off-employees>
                        </mat-step>
                    }
                    @if (config.operations) {
                        <mat-step
                            [label]="'DC.SIGN_OFF_DIALOG.OPERATIONS.TITLE' | translate"
                            [stepControl]="dialogForm.controls[SignOffDialogStep.OPERATIONS]"
                            [editable]="true"
                            [state]="SignOffDialogStep.OPERATIONS"
                        >
                            <data-terminal-sign-off-operations
                                [userId]="dialogData.userId"
                                [signOffMachines]="(machinesToSignOff$ | async) || []"
                                (dataChange)="onOperationStateChange($event)"
                                (isValid)="setStepValidity(SignOffDialogStep.OPERATIONS, $event)"
                            ></data-terminal-sign-off-operations>
                        </mat-step>
                    }
                    @if (config.timeTransfer) {
                        <mat-step
                            [label]="'DC.PURE_TIME.SUBMIT_TIMES' | translate"
                            [stepControl]="dialogForm.controls[SignOffDialogStep.TIME_TRANSFER]"
                            [editable]="true"
                            [state]="SignOffDialogStep.TIME_TRANSFER"
                        >
                            <data-terminal-sign-off-time-transfer
                                #timeTransferComponent
                                [unsubmittedTimeEntries]="unsubmittedTimeEntries"
                                [signOffMachines]="(machinesToSignOff$ | async) || []"
                                (stateChange)="onTimeTransferStateChange($event)"
                            ></data-terminal-sign-off-time-transfer>
                        </mat-step>
                    }
                    @if (config.summary) {
                        <mat-step
                            [label]="'DC.SIGN_OFF_DIALOG.SUMMARY.TITLE' | translate"
                            [stepControl]="dialogForm.controls[SignOffDialogStep.SUMMARY]"
                            [editable]="true"
                            [state]="SignOffDialogStep.SUMMARY"
                        >
                            <data-terminal-sign-off-summary
                                [signOffMachines]="(machinesToSignOff$ | async) || []"
                            ></data-terminal-sign-off-summary>
                        </mat-step>
                    }
                </mat-stepper>
            }
        </section>
        <footer class="sign-off__action-buttons">
            <button mat-stroked-button (click)="onCancelClick()">{{ 'DC.SIGN_OFF_DIALOG.CANCEL' | translate }}</button>
            <div>
                <button
                    mat-stroked-button
                    matStepperPrevious
                    (click)="onPreviousClick()"
                    [disabled]="isPreviousButtonDisable"
                >
                    {{ 'DC.SIGN_OFF_DIALOG.PREVIOUS' | translate }}
                </button>
                <button
                    mat-flat-button
                    (click)="onNextClick()"
                    [disabled]="isActionButtonDisable"
                    data-testid="sign-off-dialog-button-next"
                >
                    {{ 'DC.SIGN_OFF_DIALOG.' + actionButtonText | translate }}
                </button>
            </div>
        </footer>
    </div>
}
